import { Component, Input, OnInit } from '@angular/core';
import { SmartfeedSchedule } from '@model/product/smartfeed/smartfeed.model';

@Component({
  selector: 'app-smartfeed-scheduled-meals',
  templateUrl: './smartfeed-scheduled-meals.component.html',
  styleUrls: ['./smartfeed-scheduled-meals.component.scss'],
})
export class SmartfeedScheduledMealsComponent implements OnInit {
  @Input()
  schedules: Array<SmartfeedSchedule>;

  @Input()
  timezone: string;

  constructor() {}

  ngOnInit() {}

  getTime(time: string) {
    const timeParts = time.split(':');
    return timeParts[0] + ':' + timeParts[1];
  }
}
